import { z } from "zod";
import {
  DUE_DATE,
  TASK_STATUS,
  SCHOOL,
  ROLE,
  ASSIGN_TO,
  NAME,
  CATEGORY,
  PRIORITY,
  TERM,
} from "../consts";

export const schema = z.object({
  [NAME]: z.string().optional(),
  [CATEGORY]: z.string().optional(),
  [PRIORITY]: z.string().optional(),
  [TERM]: z.string().optional(),
  [DUE_DATE]: z.string().optional(),
  [TASK_STATUS]: z.string().optional(),
  [SCHOOL]: z.string().optional(),
  [ROLE]: z.string().optional(),
  [ASSIGN_TO]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
